import { render } from "./EngineeringDesign.vue?vue&type=template&id=6bbfbfde&scoped=true"
import script from "./EngineeringDesign.vue?vue&type=script&lang=js"
export * from "./EngineeringDesign.vue?vue&type=script&lang=js"

import "./EngineeringDesign.vue?vue&type=style&index=0&id=6bbfbfde&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbfbfde"]])

export default __exports__